/* Pielnora v2 theme - site-wide interactions.
   Product buy-box logic lives in pielnora-product.js (loaded by the Buy Area section). */
(function () {
  // restore button labels when the page is served from the back/forward cache
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-pln-orig]').forEach(function (el) {
      el.innerHTML = el.dataset.plnOrig;
    });
  });

  'use strict';

  // Mobile nav toggle
  var toggle = document.querySelector('.nav-toggle');
  var navlinks = document.getElementById('navlinks');
  if (toggle && navlinks) {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', function () {
      var open = navlinks.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Concern tiles: expand on hover/tap/focus (desktop; static stacked cards on mobile via CSS)
  var tiles = document.querySelectorAll('.glance__tile');
  tiles.forEach(function (tile) {
    tile.setAttribute('tabindex', '0');
    ['mouseenter', 'click', 'focus'].forEach(function (ev) {
      tile.addEventListener(ev, function () {
        tiles.forEach(function (x) { x.classList.remove('is-open'); });
        tile.classList.add('is-open');
      });
    });
  });
  if (tiles.length) tiles[0].classList.add('is-open');

  // Pricing cards: scrub order bump + dynamic totals + deep links into the product page
  document.querySelectorAll('.plan[data-base]').forEach(function (card) {
    var base = +card.dataset.base, bump = +card.dataset.bump;
    var chk = card.querySelector('.orderbump input');
    var ob = card.querySelector('.orderbump');
    var now = card.querySelector('.plan__price .now');
    var was = card.querySelector('.plan__price .was');
    var wasBase = +card.dataset.was || 0, wasBump = +card.dataset.wasbump || 0;
    var cta = card.querySelector('[data-plan-cta]');
    var wrap = card.closest('[data-product-url]');
    var purl = (wrap && wrap.dataset.productUrl) || '/products/sculpting-firming-system';
    function render() {
      var on = chk && chk.checked;
      if (ob) ob.classList.toggle('is-on', !!on);
      var total = base + (on ? bump : 0);
      if (now) now.textContent = '$' + total.toLocaleString('en-US');
      if (was && wasBase) was.textContent = '$' + (wasBase + (on ? wasBump : 0)).toLocaleString('en-US');
      if (cta) {
        cta.textContent = cta.dataset.label + ' - $' + total.toLocaleString('en-US');
        cta.setAttribute('href', purl + '#plan-' + cta.dataset.plan + (on ? '-scrub' : ''));
      }
    }
    if (chk) chk.addEventListener('change', render);
    render();
  });

  // Delivery rhythm selector (per group); on the PDP it also switches the
  // subscription option's Appstle selling plan (30-day vs 21-day)
  document.querySelectorAll('.cadence__opt').forEach(function (c) {
    c.addEventListener('click', function () {
      var group = c.closest('.cadence') || document;
      group.querySelectorAll('.cadence__opt').forEach(function (x) { x.classList.remove('is-active'); });
      c.classList.add('is-active');
      var i = c.querySelector('input');
      if (i) i.checked = true;
      var subOpt = document.querySelector('.buy-opt[data-plan="sub"]');
      if (subOpt) {
        var planId = /21/.test(c.textContent) ? subOpt.dataset.plan21 : subOpt.dataset.plan30;
        if (planId) subOpt.dataset.sellingPlan = planId;
      }
    });
  });

  // Direct add-to-cart CTAs (Oct 2026): [data-add-plan] buttons and the pricing-card
  // [data-plan-cta] links add the offer and go to the cart. window.PIELNORA (emitted by
  // the header section) carries variant + selling-plan ids; if it's missing or
  // incomplete, clicks fall through to the normal link (PDP deep links still work).
  var CFG = window.PIELNORA || null;
  function subPlanFor(scope) {
    var active = scope && scope.querySelector('.cadence__opt.is-active');
    var is21 = active && /21/.test(active.textContent);
    return is21 ? CFG.plan21 : (CFG.plan30 || CFG.plan21);
  }
  function itemsFor(kind, scope) {
    if (kind === 'once') {
      return CFG.bundleVariant ? [{ id: +CFG.bundleVariant, quantity: 1 }] : null;
    }
    var plan = kind === 'year' ? CFG.yearPlan : subPlanFor(scope);
    if (!plan || !CFG.gelVariant || !CFG.ftVariant) return null;
    return [
      { id: +CFG.gelVariant, quantity: 1, selling_plan: +plan },
      { id: +CFG.ftVariant, quantity: 1, selling_plan: +plan }
    ];
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-add-plan], [data-plan-cta]');
    if (!a || !CFG) return;
    if (a.id === 'buyNow' || a.id === 'buyNowMobile') return; // PDP buy box has its own handler
    var kind = a.dataset.addPlan || a.dataset.plan;
    if (!kind) return;
    var items = itemsFor(kind, a.closest('.plan'));
    if (!items) return; // config incomplete -> normal navigation
    e.preventDefault();
    var orig = a.textContent;
    a.dataset.plnOrig = a.innerHTML;
    a.textContent = 'Adding to bag…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) {
          throw new Error((err && (err.description || err.message)) || 'Something went wrong - try again');
        }, function () { throw new Error('Something went wrong - try again'); });
      }
      window.location.href = CFG.cartUrl || '/cart';
    }).catch(function (err) {
      a.textContent = (err && err.message) || 'Something went wrong - try again';
      if (window.console) console.error('[pielnora] cta add failed:', err, items);
      setTimeout(function () { a.textContent = orig; }, 5000);
    });
  });

  // Respect reduced motion for autoplay video
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }
})();
